<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS SGTEC"
        subTitulo="GESTOR"
        @click.native="$router.push({ name: 'Sgtec_Gestores_Pagamentos' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
